import React from 'react'
export function SafeImage({ src, alt = '', ...rest }) {
    return <img src={src} alt={alt} referrerPolicy="no-referrer" {...rest} />
}
